import { translate } from '@fiverr-private/i18n-react';
import { getSubCategoryKey } from './utils';

export const getTranslatedSubCategoryName = (subCategoryId: number): string =>
    translate(`${getSubCategoryKey(subCategoryId)}.name`);
